<template>
  <div>
    <div class="caption-label">Request Form Approvals </div>
    <div class="table-responsive" style="min-height: 2.5rem">
      <b-table :fields="approval_data_fields" :items="approval_datas"
               small
               thead-class="thead-light text-dark"
               style="width: calc(100% - 10px)">

        <template #cell(action)="data">
          <a class="btn btn-primary" target="_blank" :href="safeUrl(`${ frontEndUrlToUse }ftie/request-form-approval/${ data.item.request_form_id}`)">Detail</a>
        </template>
      </b-table>
    </div>
    <!--#endregion -- Header ---->
    <!--#region -- Body ---->
    <div class="caption-label">Assign Request Form </div>
    <div>
      <div class="d-flex col-8">
        <label class="font-weight-bold flex-nowrap mt-2">ApplyDate:</label>
        <input type="text" class="form-control mb-1" v-model="date_from" v-datepicker:to="date_to" />
        <label class="font-weight-bold align-self-center">～</label>
        <input type="text" class="form-control mb-1" v-model="date_to" v-datepicker:from="date_from" />
        <b-form-checkbox class="ml-2 mt-2" v-model="not_compeleted_flag"><span class="text-nowrap"><b>Proposal Not Completed</b></span></b-form-checkbox>
        <div class="col-auto mb-1 align-self-end" style="width: 12.5rem">
          <b-button @click="getToDoList()" variant="primary">Search</b-button>
          <b-button @click="downloadAssignData()" variant="btn btn-outline-primary">Export</b-button>
        </div>
      </div>

      <div class="table-responsive" style="min-height: 2.5rem">
        <b-table :fields="assign_data_fields" :items="assign_datas"
                 small
                 thead-class="thead-light text-dark"
                 style="width: calc(100% - 10px)">

          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #cell(assignDiffDays)="data">
            {{diffDays(data.item)}}
          </template>
          <template #cell(proposalDiffDays)="data">
            {{proposalDiffDays(data.item)}}
          </template>

          <template #cell(action)="data">
            <div class="d-inline-flex align-items-center gap-2">
              <a class="btn btn-primary" target="_blank" :href="safeUrl(`${ frontEndUrlToUse }ftie/request-form-approval/${ data.item.request_form_id}`)">Detail</a>
              <a v-if="login_user_name=='albert.chen'" class="btn btn-primary ml-2" target="_blank" :href="safeUrl(`${ frontEndUrlToUse }ftie/assign-rd-function/${ data.item.ftie_id}/${ data.item.request_form_id}`)">Assign</a>
              <a v-else class="btn btn-primary  ml-2 text-nowrap" target="_blank" :href="safeUrl(`${ frontEndUrlToUse }ftie/rd-check-item/${ data.item.ftie_id}/${ data.item.request_form_id}`)">RD check item</a>
            </div>
          </template>
        </b-table>
      </div>
    </div>

    <!--#endregion -- Body ---->
    <!--<div class="caption-label">Summrize Request Form </div>
    <div class="table-responsive" style="min-height: 2.5rem">
      <b-table :fields="summary_data_fields" :items="summary_datas"
               small
               thead-class="thead-light text-dark"
               style="width: calc(100% - 10px)">
        <template #cell(action)="data">
          <div style="display:inline">
            <a class="btn btn-primary" target="_blank" :href="`${ frontEndUrlToUse }ftie/request-form-approval/${ data.item.request_form_id}`">Detail</a>
            <a class="btn btn-primary" target="_blank" :href="`${ frontEndUrlToUse }ftie/rd-check-item/${ data.item.ftie_id}/${ data.item.request_form_id}`">Summarize</a>
          </div>
        </template>
      </b-table>
    </div>-->
    <div class="caption-label">Rd check Request Form </div>
    <div class="table-responsive" style="min-height: 2.5rem">
      <b-table :fields="check_item_data_fields" :items="check_item_datas"
               small
               thead-class="thead-light text-dark"
               style="width: calc(100% - 10px)">

        <template #cell(action)="data">
          <div style="display:inline">
            <a class="btn btn-primary" target="_blank" :href="safeUrl(`${ frontEndUrlToUse }ftie/request-form-approval/${ data.item.request_form_id}`)">Detail</a>
            <a class="btn btn-primary" target="_blank" :href="safeUrl(`${ frontEndUrlToUse }ftie/rd-check-item/${ data.item.ftie_id}/${ data.item.request_form_id}`)">Check</a>
          </div>
        </template>
      </b-table>
    </div>
  </div>

</template>

<script>
  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'to-do-list',
    data() {
      return {
        function_name: 'Reuqest Form Info',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        login_user_name: null,
        searching: false,
        approval_data_fields: [
          { key: 'Action', label: 'Action', thClass: 'align-middle', sortable: false },
          { key: 'request_form_id', label: 'Request Form#', thClass: 'align-middle', sortable: false },
          { key: 'ftie_id', label: 'FTIE ID', thClass: 'align-middle', sortable: false },
          { key: 'project', label: 'Project', thClass: 'align-middle', sortable: false },
          { key: 'vertical', label: 'Vertical', thClass: 'align-middle', sortable: false },
          { key: 'apply_date', label: 'Apply Date', thClass: 'align-middle', sortable: false },
          { key: 'qty', label: 'Qty', thClass: 'align-middle', sortable: false },
          { key: 'price', label: 'Price', thClass: 'align-middle', sortable: false },
          { key: 'status', label: 'Status', thClass: 'align-middle', sortable: false },
          { key: 'approval_boss', label: 'Approval Boss', thClass: 'align-middle', sortable: false },
          { key: 'approval_function', label: 'Approval Function', thClass: 'align-middle', sortable: false },
          //{ key: 'ongoing_status', label: 'Ongoing Status', thClass: 'align-middle', sortable: false },
          { key: 'model', label: 'Model', thClass: 'align-middle', sortable: false },

          //{ key: 'assign_date', label: 'Assign Date', thClass: 'align-middle', thStyle: { width: '6%' }, sortable: false },
        ],
        assign_data_fields: [
          { key: 'Action', label: 'Action', tdClass: 'align-middle', thClass: 'align-middle', thStyle: { width: '15%' }, sortable: false },
          { key: 'request_form_id', label: 'Request Form#', thClass: 'align-middle', sortable: false },
          { key: 'ftie_id', label: 'FTIE ID', thClass: 'align-middle', sortable: false },
          { key: 'project', label: 'Project', thClass: 'align-middle', sortable: false },
          //{ key: 'vertical', label: 'Vertical', thClass: 'align-middle', sortable: false },
          { key: 'apply_date', label: 'Apply Date', thClass: 'align-middle', sortable: false },
          { key: 'assign_date', label: 'Assign Date', thClass: 'align-middle', sortable: false },
          { key: 'prposol_compeleted_date', label: 'Prposol Compeleted Date', thClass: 'align-middle', sortable: false },

          { key: 'assignDiffDays', label: 'Assign Diff Days', thClass: 'align-middle', sortable: false },
          { key: 'proposalDiffDays', label: 'Proposal Diff Days', thClass: 'align-middle', sortable: false },
          { key: 'status', label: 'Status', thClass: 'align-middle', sortable: false },
          { key: 'ongoing_status', label: 'Ongoing Status', thClass: 'align-middle', sortable: false },
          { key: 'model', label: 'Model', thClass: 'align-middle', sortable: false },

        ],
        summary_data_fields: [
          { key: 'Action', label: 'Action', thClass: 'align-middle', thStyle: { width: '15%' }, sortable: false },
          { key: 'request_form_id', label: 'Request Form#', thClass: 'align-middle', sortable: false },
          { key: 'ftie_id', label: 'FTIE ID', thClass: 'align-middle', sortable: false },
          { key: 'project', label: 'Project', thClass: 'align-middle', sortable: false },
          { key: 'vertical', label: 'Vertical', thClass: 'align-middle', sortable: false },
          { key: 'create_date', label: 'Create Date', thClass: 'align-middle', sortable: false },
          { key: 'qty', label: 'Qty', thClass: 'align-middle', sortable: false },
          { key: 'price', label: 'Price', thClass: 'align-middle', sortable: false },
          { key: 'status', label: 'Status', thClass: 'align-middle', sortable: false },
          //{ key: 'ongoing_status', label: 'Ongoing Status', thClass: 'align-middle', sortable: false },
          { key: 'model', label: 'Model', thClass: 'align-middle', sortable: false },
        ],
        check_item_data_fields: [
          { key: 'Action', label: 'Action', thClass: 'align-middle', thStyle: { width: '15%' }, sortable: false },
          { key: 'request_form_id', label: 'Request Form#', thClass: 'align-middle', sortable: false },
          { key: 'ftie_id', label: 'FTIE ID', thClass: 'align-middle', sortable: false },
          { key: 'project', label: 'Project', thClass: 'align-middle', sortable: false },
          { key: 'vertical', label: 'Vertical', thClass: 'align-middle', sortable: false },
          { key: 'create_date', label: 'Create Date', thClass: 'align-middle', sortable: false },
          { key: 'qty', label: 'Qty', thClass: 'align-middle', sortable: false },
          { key: 'price', label: 'Price', thClass: 'align-middle', sortable: false },
          { key: 'status', label: 'Status', thClass: 'align-middle', sortable: false },
          { key: 'owner', label: 'Owner', thClass: 'align-middle', sortable: false },
          { key: 'flow_stage', label: 'Flow Stage', thClass: 'align-middle', sortable: false },
          { key: 'model', label: 'Model', thClass: 'align-middle', sortable: false },
        ],
        feas_function: null,
        request_form: null,
        date_from: '',
        date_to: '',
        approval_datas: [],
        assign_datas: [],
        summary_datas: [],
        check_item_datas: [],
        already_first_search_flag: true,
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        not_compeleted_flag: true
      }
    },
    created() {
      let self = this;
      self.checkLoggedIn();
      self.setDefaultDateForSearching();
      self.getToDoList();
    },
    computed: {
      date_from_computed() {
        let str = moment(this.date_from, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      },
      date_to_computed() {
        let str = moment(this.date_to, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      }
    },
    mounted: function () {
      this.checkLoggedIn();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
    },
    methods: {
      setDefaultDateForSearching() {
        console.log("setDefaultDateForSearching");
        let self = this;
        let today = moment();
        let defaultStartDate = moment().subtract(2, 'months');
        self.date_from = defaultStartDate.format('YYYY-MMM-DD');
        self.date_to = today.format('YYYY-MMM-DD');
      },
      diffDays(item) {
        if (item.assign_date===null) {
          return null
        }
        let appply_date = moment(new Date(item.apply_date));
        let assign_date = moment(new Date(item.assign_date));
        let days = assign_date.diff(appply_date, 'day');
        let exclude_holiday_diff = 0;
        if (days === 0) {
          exclude_holiday_diff = 1;
          item.assignDiffDays = exclude_holiday_diff;
          return exclude_holiday_diff;
        }
        while (days > 0) {
          appply_date = appply_date.add(1, 'days');
          // decrease "days" only if it's a weekday.
          console.log("weekdays");
          console.log(appply_date.isoWeekday());
          if (appply_date.isoWeekday() !== 6 && appply_date.isoWeekday() !== 7) {

            exclude_holiday_diff += 1;
          }
          days -= 1;
        }
        item.assignDiffDays = exclude_holiday_diff;
        return exclude_holiday_diff;
      },
      proposalDiffDays(item) {
        if (item.prposol_compeleted_date === null || item.assign_date === null) {
          item.proposalDiffDays =null
          return null
        }
        let prposol_compeleted_date = moment(new Date(item.prposol_compeleted_date));
        let assign_date = moment(new Date(item.assign_date));
        let days = prposol_compeleted_date.diff(assign_date, 'day');
        let exclude_holiday_diff = 0;
        if (days === 0) {
          exclude_holiday_diff = 1;
          item.proposalDiffDays = exclude_holiday_diff;
          return exclude_holiday_diff;
        }
        while (days > 0) {
          prposol_compeleted_date = prposol_compeleted_date.add(1, 'days');
          // decrease "days" only if it's a weekday.
          console.log("weekdays");
          console.log(prposol_compeleted_date.isoWeekday());
          if (prposol_compeleted_date.isoWeekday() !== 6 && prposol_compeleted_date.isoWeekday() !== 7) {

            exclude_holiday_diff += 1;
          }
          days -= 1;
        }
        item.proposalDiffDays = exclude_holiday_diff;
        return exclude_holiday_diff;
      },
      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location = self.frontEndUrlToUse + 'azure-login';
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);


        this.login_user_name = user_name;


      },
      getToDoList() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/get-to-do-list/';

        let request_data = {
          user_name: self.login_user_name,
          date_from: self.date_from_computed,
          date_to: self.date_to_computed,
          not_compeleted_flag: self.not_compeleted_flag,
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        let to_do_list = null;
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              to_do_list = JSON.parse(res['to_do_list']);
              self.approval_datas = to_do_list.approval_datas;
              self.assign_datas = to_do_list.assign_datas;
              self.summary_datas = to_do_list.summary_datas;
              self.check_item_datas = to_do_list.check_item_datas;

            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })
      },
      downloadAssignData() {
        let self = this;
        self.getToDoList();
        self.$nextTick(() => {
          let downloadTime = new Date();
          downloadTime = downloadTime.toISOString();
          let url = self.$root.baseUrl + '/ftie/download-assign-data/';
          let request_data = {
            assign_data: self.assign_datas,
            downloadTime: downloadTime
          };

          const params = {
            token: encodeURI(self.$store.state.token),
            username: encodeURI(self.$store.state.username),
          };
          eventHub.$emit('loading', true);
          self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
            .then((response) => {

              if (response.status === 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                let dateTimeStr = _.replace(downloadTime, '.', '');
                dateTimeStr = _.replace(dateTimeStr, ':', '');
                dateTimeStr = _.replace(dateTimeStr, '-', '');
                let file_name = 'assign_data_report_' + dateTimeStr + '.xlsx';
                console.log("file_name =" + file_name);
                link.setAttribute('download', file_name);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
              }
              else if (res.description == "login") {
                self.$session.destroy();
                self.$store.commit('clearToken');
                var url = self.$root.baseUrl + '/auth/logout/';
                self.$axios.get(url)
                  .then((res) => {
                    console.log('logout');
                    self.$router.push("/");
                  })
                window.location = self.frontEndUrlToUse + 'azure-login';
              } else {
                self.$message.exception('Internal Server Error!');
                console.log(res.description);
              }
            }, (error) => {
              console.log(error);
              self.$message.exception('Internal Server Error!');
            })
            .finally(() => {
              eventHub.$emit('loading', false);
            })
        });
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/_ToDoList.vue